import { isAxiosError } from "axios"

import axiosInstance from "~/api/api.axiosInstance"

import type {
  UpdateProposalUtilitySelectionDto,
  UpdateProposalUtilitySelectionResponseDto,
  UtilityOptionsResponseDto,
} from "../dto/proposal-utility.dto"

export class ProposalUtilityService {
  public async getUtilityOptions(
    proposalId: string,
  ): Promise<UtilityOptionsResponseDto> {
    try {
      const response = await axiosInstance.get<UtilityOptionsResponseDto>(
        `/v2/proposal-utility/${proposalId}/options`,
      )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to fetch utility options`)
    }
  }

  public async updateUtilitySelection(
    proposalId: string,
    data: UpdateProposalUtilitySelectionDto,
  ): Promise<UpdateProposalUtilitySelectionResponseDto> {
    try {
      const response =
        await axiosInstance.put<UpdateProposalUtilitySelectionResponseDto>(
          `/v2/proposal-utility/${proposalId}/selection`,
          data,
        )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to update utility selection`)
    }
  }
}

function toServiceError(error: unknown, fallbackMessage: string): Error {
  if (isAxiosError(error)) {
    return new Error(error.response?.data?.message ?? fallbackMessage)
  }
  if (error instanceof Error) {
    return error
  }

  return new Error(fallbackMessage)
}

export const proposalUtilityService = new ProposalUtilityService()
